import { createUrlQueryParams } from "../utils/urlUtils";
import axiosInstance from "./axios";
import { AbstractModel } from "./models/abstractProduct.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchAbstractProductData = async (
  bearerToken: string,
  companyId: number,
  page: number = 1,
  searchStrings?: string[],
  exactMatch?: boolean,
): Promise<{ data: AbstractModel[]; isSynkkaData: boolean }> => {
  try {
    let url = createUrlQueryParams(
      `${apiUrl}/Products/${companyId}/abstractProducts`,
      searchStrings,
      page,
      undefined,
      exactMatch,
    );

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return {
      data: response.data,
      isSynkkaData: false,
    };
  } catch (error) {
    console.error("Failed to fetch abstract product data:", error);
    throw error;
  }
};

export const fetchAbstractModelsWithIdentifiers = async (
  bearerToken: string,
  companyId?: number,
  searchStrings?: string[],
): Promise<AbstractModel[]> => {
  try {
    if (!searchStrings || searchStrings.length === 0) {
      return [];
    }

    let url = companyId
      ? createUrlQueryParams(
        `${apiUrl}/Products/${companyId}/abstractProducts`,
        searchStrings,
      )
      : createUrlQueryParams(
        `${apiUrl}/Products/abstractProducts`,
        searchStrings,
      );

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch abstract models with identifiers:", error);
    throw error;
  }
};

export const fetchAllAbstractProducts = async (
  bearerToken: string,
  searchStrings: string[],
): Promise<{ data: AbstractModel[]; isSynkkaData: boolean }> => {
  try {
    const url = createUrlQueryParams(
      `${apiUrl}/Products/abstractProducts`,
      searchStrings,
    );
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return {
      data: response.data,
      isSynkkaData: false,
    };
  } catch (error) {
    console.error("Failed to fetch all abstract products:", error);
    throw error;
  }
};

export const deleteProduct = async (
  bearerToken: string,
  companyId: number,
  identifier: string,
): Promise<void> => {
  try {
    await axiosInstance.delete(
      `${apiUrl}/Products/${companyId}/delete/${identifier}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      },
    );
  } catch (error) {
    console.error("Failed to delete product:", error);
    throw error;
  }
};
